import { render } from "./FormInput.vue?vue&type=template&id=73c56448&scoped=true"
import script from "./FormInput.vue?vue&type=script&lang=js"
export * from "./FormInput.vue?vue&type=script&lang=js"

import "./FormInput.vue?vue&type=style&index=0&id=73c56448&scoped=true&lang=css"

import exportComponent from "/srv/strapi/LessMessAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73c56448"]])

export default __exports__